import GetLoading from "../../share/getLoading";
import { useEffect, useState, useRef } from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import Quill from "quill";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import {
  PlusCircleOutlined,
  CloseOutlined,
  PrinterOutlined,
  EditOutlined,
  FilterOutlined,
  ReloadOutlined,
  CheckCircleFilled,
  EyeOutlined,
  SaveOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";
import {
  Table,
  Modal,
  Button,
  Input,
  Space,
  Tabs,
  message,
  Tag,
  Popconfirm,
  Avatar,
  Spin,
  Checkbox,
  Select,
} from "antd";
import "../../styles/Home-module.css";
import "./print.css";
import { request } from "../../share/request";
import { getStatusContent, getTageStyle } from "../../share/getStatusContent";
import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";

import { getCurrentUser, getPermission } from "../../share/getProfile";
import FormPantient from "../caractivity/FormPantient";
import { useReactToPrint } from "react-to-print";
import { BsDownload, BsEyeglasses } from "react-icons/bs";
import FilterDate from "../../share/FilterDate";
import dayjs from "dayjs";
import DonorRegisterForm from "./Donor_Register";
import DonationDiagnosis from "./DonationDiagnosis";
import { FaEdgeLegacy } from "react-icons/fa6";
import PrintDonor from "./PrintDonorRegister";
import Content from "./Content";
import ReactDOMServer from "react-dom/server";
import { BiBadgeCheck } from "react-icons/bi";
import PrintCertificate from "./PrintCertificate";
import { linkPath } from "../../share/helper";
import { openNotification } from "../../share/message";
import { useLocation } from "react-router-dom"; // Import useLocation for routing
import FilterDateTime from "../../share/FilterDateTime";
import { IoQrCodeOutline } from "react-icons/io5";
import PrintDonorQRCode from "./PrintDonorQRCode";
const { Option } = Select;
// 1. Add custom font sizes (in px)
// Register font sizes in px
const Size = Quill.import("formats/size");
const Parchment = Quill.import("parchment");
Size.whitelist = [
  "12px",
  "13px",
  "14px",
  "15px",
  "16px",
  "17px",
  "18px",
  "20px",
  "24px",
  "28px",
  "32px",
];

Quill.register(Size, true);
const LineHeight = new Parchment.Attributor.Style("lineheight", "line-height", {
  scope: Parchment.Scope.INLINE,
  whitelist: ["1", "1.15", "1.5", "2", "2.5", "3"],
});

Quill.register(LineHeight, true);
// Register custom fonts
const Font = new Parchment.Attributor.Style("font", "font-family", {
  scope: Parchment.Scope.INLINE,
  whitelist: [
    "Moul",
    "Content",
    "Arial",
    "Times New Roman",
    "Helvetica",
    "Courier New",
    "Verdana",
    "Georgia",
    "Roboto",
    "Noto Sans",
  ],
});
Quill.register(Font, true);
const BloodDonation = () => {
  const printRef = useRef();
  const getProfile = getCurrentUser();
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [openModelDiag, setOpenModelDiag] = useState(false);
  const [id, setID] = useState("");
  const [donor_id, setDonorID] = useState("");
  const [expandedRowIds, setExpandedRowIds] = useState([]);
  const [list, setList] = useState([]);
  const [total, setTotal] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [disablePrint, setDisablePrint] = useState(false);
  const location = useLocation(); // Get the current route
  // print scerify cate :
  const [openTemplate, setOpenTemplate] = useState(false);
  const [objFilter, setObjFileter] = useState({
    search: "",
    page_number: 1,
    item_per_page: 10,
    orgcode: getProfile.org_code,
    date_start: null,
    date_end: null,
  });

  const [form, setForm] = useState([]);
  const [formDiag, setFormDiag] = useState([]);
  // -----------------  permisstion page --------------------
  const userPermission = getPermission();
  const blood_formPageValue = userPermission.find(
    (permission) => permission.pagename === "blood_donation"
  ) || { add: 0, edit: 0, deleted: 0, print: 0 };
  const {
    add: Addvalue,
    edit: Editvalue,
    deleted: Deletevalue,
    print: PrintValue
  } = blood_formPageValue;
  // -----------------  end permisstion page --------------------

  const getList = async (objFilter) => {
    setList([]);
    setLoading(true);
    const param = new URLSearchParams({
      search: objFilter.search,
      page_number: objFilter.page_number,
      item_per_page: objFilter.item_per_page,
      orgcode: getProfile.org_code,
    });
    if (objFilter.date_start) param.append("date_start", objFilter.date_start);
    if (objFilter.date_end) param.append("date_end", objFilter.date_end);
    try {
      const res = await request("casedonator?" + param.toString(), "get", {});

      await new Promise((resolve) => setTimeout(resolve, 400));
      console.log(res);
      if (res && res.api_data) {
        const dataList = Array.isArray(res.api_data) ? res.api_data : [];
        setList(dataList);
        setTotal(res.total);
        console.table(dataList);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList(objFilter);
  }, []);

  // Helper function to get random color from a preset list
  const getRandomColor = () => {
    const colors = [
      "magenta",
      "red",
      "volcano",
      "orange",
      "gold",
      "lime",
      "green",
      "cyan",
      "blue",
      "geekblue",
      "purple",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };
  // Toggle expand on row id click
  const toggleRow = (id) => {
    setExpandedRowIds((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };
  const pageSize = 10; // Define your page size
  const currentPage = objFilter.page_number || 1; // Get current page from filter
  const columns = [
    {
      title: "ល.រ",
      key: "index",
      render: (value, record, index) => {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return (
          <div
            style={{
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              toggleRow(record.id);
            }}
          >
            {serialNumber}
            <Checkbox
              key={record.id}
              checked={checkboxes[currentPage]?.[record.id] || false}
              onChange={() => handleCheckboxChange(record.id)}
              style={{
                transform: "scale(1.3)",
                marginRight: 5,
                marginLeft: 10,
              }}
            ></Checkbox>
          </div>
        );
      },
    },

    {
      key: "full_name",
      title: "ឈ្មោះ",
      dataIndex: "full_name_kh", // We still use kh for dataIndex but render custom content
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Left: Avatar */}
          <Avatar
            style={{ marginRight: 12, backgroundColor: getRandomColor() }}
            size="large"
            // Use first letters from Khmer or fallback to Eng name initials
            children={
              record.full_name_kh
                ? record.full_name_kh
                  .split(" ")
                  .map((w) => w[0])
                  .join("")
                  .toUpperCase()
                : record.full_name_eng
                  ? record.full_name_eng
                    .split(" ")
                    .map((w) => w[0])
                    .join("")
                    .toUpperCase()
                  : "?"
            }
          />

          {/* Right: Names */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontWeight: "bold", fontSize: 14 }}>
              {record.full_name_kh}
            </span>
            <span style={{ color: "#999", fontSize: 12 }}>
              {record.full_name_eng}
            </span>
          </div>
        </div>
      ),
    },
    {
      key: "gender",
      title: "ភេទ",
      dataIndex: "gender",
      render: (value) => (
        <Tag
          color={value === "Male" ? "blue" : "pink"}
          style={{ fontWeight: "bold" }}
        >
          {value === "Male"
            ? "ប្រុស"
            : value === "Female"
              ? "ស្រី"
              : "ផ្សេងទៀត"}
        </Tag>
      ),
    },
    {
      key: "age",
      title: "អាយុ",
      dataIndex: "age",
    },
    {
      key: "province_kh",
      title: "ខេត្ត/ក្រុង",
      dataIndex: "province_kh",
    },
    {
      key: "phone1",
      title: "លេខទំនាក់ទំនង",
      dataIndex: "phone1",
    },
    {
      key: "blood_group_abo",
      title: "ក្រុមឈាម ABO",
      dataIndex: "blood_group_abo",
      render: (record, item, index) => (
        <Tag color={getRandomColor()} style={{ fontWeight: "bold" }}>
          {item.blood_group_abo || "មិនមាន"} {item.rhesus}
        </Tag>
      ),
    },
    {
      key: "total_donations",
      title: "ចំនួនបរិច្ចាកឈាម",
      dataIndex: "total_donations",
      render: (value) => (
        <Tag color={getRandomColor()} style={{ fontWeight: "bold" }}>
          {value}
        </Tag>
      ),
    },

    {
      key: "last_donation_date",
      title: "ថ្ងៃបរិច្ចាគចុងក្រោយ",
      dataIndex: "last_donation_date",
      render: (value) => (
        <Tag color="blue">
          {value ? dayjs(value).format("DD/MM/YYYY") : "គ្មានទិន្នន័យ"}
        </Tag>
      ),
    },
    {
      key: "create_by",
      title: "អ្នកបង្កើត",
      dataIndex: "create_by",
      render: (text, record) => {
        return (
          <div style={{ lineHeight: 1.3 }}>
            <div style={{ fontWeight: "bold" }}>{record.create_by}</div>
            <div style={{ fontSize: 12, color: "#555" }}>
              {record.create_date
                ? dayjs(record.create_date).format("DD/MM/YYYY, h:mm:ss A")
                : "-"}
            </div>
          </div>
        );
      },
    },

    {
      key: "action",
      title: "សកម្មភាព",
      dataIndex: "action",
      render: (value, item) => (
        <Space>
          <Button
            disabled={!Editvalue}
            type="primary"
            onClick={() => handleEdit(item)}
            icon={<EditOutlined />}
          />
          {/* viewer report by id */}
          <Button
            onClick={() => handleViewer(item)}
            disabled={!Editvalue}
            className="buttonstylekhmer"
            type="primary"
            icon={<EyeOutlined />}
          />
          {/* Print button */}
          <Button
            onClick={() => handlePrint(item)}
            disabled={!Editvalue}
            type="primary"
            icon={<PrinterOutlined />}
          />
          {/* Print button QRcode */}
          {/* <Button
            onClick={() => handlePrintQR(item)}
            disabled={!Editvalue}
            color="cyan" variant="solid"
            icon={<IoQrCodeOutline />}
          /> */}

          {/* Print button with QR code  ref */}
          <div style={{ display: "none" }}>
            {printDataQR && (
              <PrintDonorQRCode
                ref={componentRef}
                data={printDataQR}
              // dataDonor={printDataItem}
              />
            )}
          </div>
          {/* Print button with forward ref */}

          <div style={{ display: "none" }}>
            {printData && (
              <PrintDonor
                ref={componentRef}
                data={printData}
                dataDonor={printDataItem}
              />
            )}
          </div>

          {/* Delete button with confirmation */}
          <Popconfirm
            title="Delete the item"
            description="Are you sure to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => handleDelete(item)}
          >
            <Button
              danger
              disabled={!Deletevalue}
              type="primary"
              icon={<CloseOutlined />}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const [shouldPrint, setShouldPrint] = useState(false);

  const handleDelete = async (item) => {
    try {
      const res = await request(`donator/${item.id}`, "delete", {});
      if (res) {
        message.success("Delete Successfully");
        getList(objFilter);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };
  const handleDeleteDiag = async (item) => {
    try {
      const res = await request(`donatordiag/${item.id}`, "delete", {});
      if (res) {
        message.success("Delete Successfully");

        // Remove from expanded row details
        if (expandedRecord) {
          setDoctorDetailsMap((prev) => {
            const updatedDetails = prev[expandedRecord.id]?.filter(
              (diag) => diag.id !== item.id
            );
            return {
              ...prev,
              [expandedRecord.id]: updatedDetails,
            };
          });
        }
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };

  // const handlePrintQR = (item) => {
  //   const dataQR = {
  //     qrSrc: `https://blood-donation-pi-green.vercel.app/${item.ingerate_qrcode_id}`,
  //     fullname: item.full_name_kh,
  //     phone: item.phone1
  //   };

  //   setPrintDataQR(dataQR);

  //   // Wait data injected → then print
  //   setTimeout(() => {
  //     printRefRegisterQR();
  //   }, 100);  
  // };

  const handlePrintQRMultiple = () => {
    const rawData = localStorage.getItem("selectedFullnames_isCheck");
    if (!rawData) return;

    const parsedData = JSON.parse(rawData); // ARRAY

    const dataQR = parsedData.map(item => ({
      qrSrc: `https://blood-donation-pi-green.vercel.app/${item.qrcode}`,
      fullname: item.fullname,
      phone: item.phone || " ", // if not exist
      gender: item.gender === 'Male' ? 'ប្រុស' : 'ស្រី' || ""
    }));

    setPrintDataQR(dataQR);
    console.log(dataQR)
    setTimeout(() => {
      printRefRegisterQR();
    }, 100);
  };



  const onChangePage = (number) => {
    setPageNumber(number);

    setObjFileter({
      search: objFilter.search,
      page_number: number,
      item_per_page: objFilter.item_per_page,
      orgcode: getProfile.org_code,
    });
    getList(objFilter);
  };

  const [clear, setClear] = useState(0);
  const closeForm = () => {
    setOpenModel(false);
    getList(objFilter);
  };
  const closeFormDiag = async () => {
    setOpenModelDiag(false);

    if (expandedRecord) {
      const res = await request(`donator/${expandedRecord.id}`, "get", {});
      if (res.api_donor) {
        setDoctorDetailsMap((prev) => ({
          ...prev,
          [expandedRecord.id]: res.api_donor,
        }));
      }
    }
  };
  // Update this function to load the form and print it
  const componentRef = useRef();

  const [printData, setPrintData] = useState(null);
  const [printDataSingle, setPrintDataSingle] = useState([]);
  const [dataViewer, setDataViewer] = useState(null);
  const [printDataItem, setPrintDataItem] = useState(null);

  const [printItemSigle, setPrintItemSigle] = useState(null);
  const [printCertificate, setPrintCertificate] = useState(false);
  const [dataViewerItem, setDataViewerItem] = useState(null);
  const [readyToPrint, setReadyToPrint] = useState(false);


  //  print Qr code 
  const [printDataQR, setPrintDataQR] = useState(null);
  const [printQR, setPrintQRcode] = useState(false)
  const [readyToPrintQR, setReadyToPrintQR] = useState(false);
  useEffect(() => {
    if (readyToPrintQR && componentRef.current) {
      printRefRegisterQR();
      setReadyToPrintQR(false);
    }
  }, [readyToPrintQR]);

  // Effect to watch for printData changes
  useEffect(() => {
    if (!printData?.id) return; // if no id, skip

    const fetchAndPrint = async () => {
      setLoading(true);
      try {
        const res = await request(`donator/${printData.id}`, "get", {});
        if (res.api_donor) {
          setPrintDataItem(res.api_donor);
          console.log("data item donor :", res.api_donor);

          // small delay to ensure state updates before printing
          setTimeout(() => {
            printRefRegister();
          }, 500);
        } else {
          console.log("no item donor");
        }
      } catch (error) {
        console.error("Error fetching donor data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAndPrint();
  }, [printData]);




  const handlePrint = (item) => {
    console.log("item print : ", item.id);
    setPrintData(item);
  };

  useEffect(() => {
    if (readyToPrint && componentRef.current) {
      printRefRegister();
      setReadyToPrint(false);
    }
  }, [readyToPrint]);
  useEffect(() => {
    if (printCertificate === true && componentRef.current) {
      setOpenTemplate(false);
      printRefCertificate();
      setPrintCertificate(false);
    }
  }, [printCertificate]);
  const handlePrintSingleItem = (item) => {
    setPrintItemSigle(item);
    console.log("data donor sigle item: ", printItemSigle);
    setReadyToPrint(true);
  };
  const printRefRegister = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "ប័ណ្ណចុះឈ្មោះ",
    removeAfterPrint: true,
  });
  const printRefRegisterQR = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Print QRcode",
    removeAfterPrint: true,
  });
  const printRefCertificate = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Certificate",
    removeAfterPrint: true,
  });
  const handleViewer = async (item) => {
    setDataViewer(item);

    try {
      const res = await request(`donator/${item.id}`, "get", {});
      if (res.api_donor) {
        setDataViewerItem(res.api_donor);

        // ✅ Wait a tick to ensure state is updated (optional, for safety)
        setTimeout(() => {
          const contentHTML = ReactDOMServer.renderToString(
            <Content dataViewer={item} dataViewerItem={res.api_donor} />
          );

          const printWindow = window.open("", "_blank");
          printWindow.document.write(`
          <html>
            <head>
              <title>ប័ណ្ណចុះឈ្មោះ</title>
               <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/antd/dist/antd.min.css" />
        <style>
          @page {
            size: A4;
           
          }
          body {
            font-family: 'Content', Arial, sans-serif;
            
          }
        </style>
            <body>
              ${contentHTML}
            </body>
          </html>
        `);
          printWindow.document.close();
        }, 0); // Ensures state updates before generating HTML
      }
    } catch (err) {
      console.error("Failed to fetch donor data", err);
    }
  };
  const handlePrintComplete = () => {
    setShouldPrint(false); // Reset the flag after printing
  };
  // Print trigger after component is rendered
  useEffect(() => {
    if (shouldPrint && printRef.current) {
      setTimeout(() => {
        printComponent(); // trigger printing
      }, 500); // wait briefly to render
    }
    getList(objFilter);
  }, [shouldPrint]);
  const printComponent = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => setShouldPrint(false), // clean up
  });

  const [openModel_Filter, setOpenModel_Filter] = useState(false);
  const [filteredDate, setFilteredDate] = useState({ start: null, end: null });
  const handleFilterDateChange = async (dateRange) => {
    setFilteredDate(dateRange); // save it
    console.log("Received from FilterDate:", dateRange.start, dateRange.end);

    const newFilter = {
      ...objFilter,
      date_start: dateRange.start,
      date_end: dateRange.end,
    };
    setObjFileter(newFilter);
    getList(newFilter);
  };


  const handleDownloadReport = async (dateRange) => {
    try {
      const params = new URLSearchParams({
        org_code: 20,
        start_datetime: `${dateRange.date_start} ${dateRange.time_start}:00`,
        end_datetime: `${dateRange.date_end} ${dateRange.time_end}:00`,
      });

      const res = await request(`donatorgetreportv1?${params.toString()}`, "get", {});

      if (!res || typeof res !== "object") {
        console.error("API did not return JSON:", res);
        return;
      }

      // Prevent undefined errors ⛔
      const summaryAbo = Array.isArray(res.summaryAbo) ? res.summaryAbo : [];
      const summaryOccupation = Array.isArray(res.summaryOccupation) ? res.summaryOccupation : [];
      const details = Array.isArray(res.details) ? res.details : [];

      const templatePath = process.env.PUBLIC_URL + "/template/donator_sum_report.xlsx";
      const response = await fetch(templatePath);
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      /* =====================================================
                       SUMMARY SHEET 
      ======================================================*/
      const summarySheet = workbook.getWorksheet("Summary");

      // Remove merged cells
      summarySheet._merges = {};

      /* -----------------------------------------------
          1️⃣ SUMMARY 1 (ABO ONLY) → Start at A2
      ------------------------------------------------ */
      summaryAbo.forEach((row, i) => {
        const r = summarySheet.getRow(2 + i);
        r.getCell("A").value = row.abo_group || "";
        r.getCell("B").value = row.male || 0;
        r.getCell("C").value = row.female || 0;
        r.getCell("D").value = row.total || 0;
        r.commit();
      });

      /* -----------------------------------------------
          2️⃣ SUMMARY 2 (ABO + OCCUPATION + WORKPLACE)
          → Start at H1
      ------------------------------------------------ */

      let rowOffset = 2; // start at row 2

      summaryOccupation.forEach((row) => {
        summarySheet.getCell(`H${rowOffset}`).value = row.abo_group || "";
        summarySheet.getCell(`I${rowOffset}`).value = row.occupation || "";
        summarySheet.getCell(`J${rowOffset}`).value = row.workplace || "";
        summarySheet.getCell(`K${rowOffset}`).value = row.male || 0;
        summarySheet.getCell(`L${rowOffset}`).value = row.female || 0;
        summarySheet.getCell(`M${rowOffset}`).value = row.total || 0;
        rowOffset++;
      });



      /* =====================================================
                     DETAILS SHEET
    ======================================================*/
      const detailsSheet = workbook.getWorksheet("Details");

      details.forEach((row, i) => {
        const r = detailsSheet.getRow(2 + i);

        r.getCell(1).value = i + 1; // sequential number starting from 1
        r.getCell(2).value = row.donator_code || "";
        r.getCell(3).value = row.full_name_kh || "";
        r.getCell(4).value = row.full_name_eng || "";
        r.getCell(5).value = row.age || "";
        r.getCell(6).value = row.gender || "";
        r.getCell(7).value = row.phone1 || "";
        r.getCell(8).value = row.province || "";
        r.getCell(9).value = row.city || "";
        r.getCell(10).value = row.commune || "";
        r.getCell(11).value = row.village || "";
        r.getCell(12).value = row.blood_group_abo || "";
        r.getCell(13).value = row.occupation || "";
        r.getCell(14).value = row.workplace || "";
        r.getCell(15).value = row.position || "";
        r.getCell(16).value = row.weight_kg || "";
        r.getCell(17).value = row.hemoglobin || "";
        r.getCell(18).value = row.blood_pressure_systolic || "";
        r.getCell(19).value = row.blood_pressure_diastolic || "";
        r.getCell(20).value = row.hematocrit || "";
        r.getCell(21).value = row.pulse_rate || "";

        r.commit();
      });

      /* =====================================================
                       SAVE FILE
      ======================================================*/
      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer]),
        `donator_sum_report_${dateRange.date_start}_${dateRange.date_end}.xlsx`
      );

    } catch (err) {
      console.error("Download failed:", err);
    }
  };



  // const handleDownloadReport = async (dateRange) => {
  //   try {
  //  const params = new URLSearchParams({
  //   org_code: 20,
  //   start_datetime: `${dateRange.date_start} ${dateRange.time_start}:00`, // add seconds
  //   end_datetime: `${dateRange.date_end} ${dateRange.time_end}:00`,       // add seconds
  // });
  //     // Use your custom request function
  //     const res = await request(`donatorgetreport?${params.toString()}`, "get", {});

  //     if (!res || typeof res !== "object") {
  //       console.error("API did not return JSON:", res);
  //       return;
  //     }

  //     const { summary, details } = res;

  //     // Load template
  //     const templatePath = process.env.PUBLIC_URL + "/template/donator_sum_report.xlsx";
  //     const response = await fetch(templatePath);
  //     const arrayBuffer = await response.arrayBuffer();

  //     const workbook = new ExcelJS.Workbook();
  //     await workbook.xlsx.load(arrayBuffer);

  //     // Fill sheets (same as before)
  //     const summarySheet = workbook.getWorksheet("Summary");
  //     summary.forEach((row, i) => {
  //       const r = summarySheet.getRow(2 + i);
  //       r.getCell(1).value = row.abo_group;
  //       r.getCell(2).value = row.male;
  //       r.getCell(3).value = row.female;
  //       r.getCell(4).value = row.total;
  //       r.commit();
  //     });






  //     const detailsSheet = workbook.getWorksheet("Details");
  //     details.forEach((row, i) => {
  //       const r = detailsSheet.getRow(2 + i);
  //       r.getCell(1).value = row.donor_id;
  //       r.getCell(2).value = row.donator_code;
  //       r.getCell(3).value = row.full_name_kh;
  //       r.getCell(4).value = row.full_name_eng;
  //       r.getCell(5).value = row.age;
  //       r.getCell(6).value = row.gender;
  //       r.getCell(7).value = row.phone1;
  //       r.getCell(8).value = row.province;
  //       r.getCell(9).value = row.city;
  //       r.getCell(10).value = row.commune;
  //       r.getCell(11).value = row.village;
  //       r.getCell(12).value = row.blood_group_abo;
  //        r.getCell(13).value = row.occupation;
  //       r.getCell(14).value = row.workplace;
  //       r.getCell(15).value = row.position;
  //       r.getCell(16).value = row.weight_kg;
  //       r.getCell(17).value = row.hemoglobin;
  //       r.getCell(18).value = row.blood_pressure_systolic;
  //       r.getCell(19).value = row.blood_pressure_diastolic;
  //       r.getCell(20).value = row.hematocrit;
  //       r.getCell(21).value = row.pulse_rate;
  //       r.commit();
  //     });

  //     const buffer = await workbook.xlsx.writeBuffer();
  //     FileSaver.saveAs(new Blob([buffer]), `donator_sum_report_${dateRange.start}_${dateRange.end}.xlsx`);
  //   } catch (err) {
  //     console.error("Download failed:", err);
  //   }
  // };


  const handleClearSearch = () => {
    setCheckboxes([])
    console.log("clear");
    const newFilter = {
      ...objFilter,
      search: "",
      date_start: null,
      date_end: null,
    };

    setObjFileter(newFilter);
    getList(newFilter);

  };
  const [expandedRecord, setExpandedRecord] = useState(null);
  const [doctorDetailsMap, setDoctorDetailsMap] = useState({});
  const [loadingExpandId, setLoadingExpandId] = useState(null);
  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            backgroundColor: "#1f75c6ff", // blue header bg
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            ...props.style,
          }}
        >
          {props.children}
        </th>
      ),
    },
  };

  const expandedRowRender = (record) => {
    if (loadingExpandId === record.id) {
      return <Spin tip="Loading..." />;
    }

    const details = doctorDetailsMap[record.id] || [];

    return (
      <Table
        components={components}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "even-row" : "odd-row"
        }
        columns={[
          {
            title: "ល.រ",
            dataIndex: "id",
            key: "id",
            render: (_, __, index) => <Tag>{index + 1}</Tag>,
          },
          {
            title: "លេខបរិច្ចាគ",
            dataIndex: "donator_code",
            key: "donator_code",
            render: (text) => (
              <div>
                <Space>
                  <CheckCircleFilled style={{ color: "#1f75c6ff" }} />
                  <span style={{ fontWeight: "bold" }}>{text}</span>
                </Space>
              </div>
            ),
          },
          {
            title: "ថ្ងៃបរិច្ចាគ",
            dataIndex: "diagnosis_date",
            key: "diagnosis_date",
            render: (text) => (
              <Tag color={getRandomColor()}>
                {dayjs(text).format("DD/MM/YYYY")}
              </Tag>
            ),
          },
          {
            title: "ក្រុមឈាម",
            dataIndex: "blood_group_abo",
            key: "blood_group_abo",
            render: (record, text, index) => (
              <Tag color={getRandomColor()} style={{ fontWeight: "bold" }}>
                {text.blood_group_abo}.{text.rhesus}
              </Tag>
            ),
          },
          {
            title: "ចំនួនបរិមាណឈាម (ml)",
            dataIndex: "blood_amount_ml",
            key: "blood_amount_ml",
            render: (text) => <Tag color={getRandomColor()}>{text} (ml)</Tag>,
          },
          {
            title: "អេម៉ូក្លូប៊ីន",
            dataIndex: "hemoglobin",
            key: "hemoglobin",
            render: (text) => <Tag color={getRandomColor()}>{text}</Tag>,
          },
          {
            title: "សម្ពាធឈាម (mmHg)",
            dataIndex: "blood_pressure_systolic",
            key: "blood_pressure_systolic",
            render: (record, text, index) => (
              <Tag color={getRandomColor()}>
                {text.blood_pressure_systolic}/{text.blood_pressure_diastolic}
              </Tag>
            ),
          },

          {
            title: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                {" សកម្មភាព​ "}
                <Button
                  className="buttonstylekhmer"
                  type="primary"
                  onClick={() => {
                    setOpenModelDiag(true);
                    setDonorID(record.id);
                    setID(null);
                  }}
                  icon={<PlusCircleOutlined />}
                />
              </div>
            ),
            dataIndex: "action",
            key: "action",
            render: (value, item) => (
              <Space>
                <Button
                  disabled={!Editvalue}
                  color="green"
                  variant="filled"
                  onClick={() => handleEditRow(item)}
                  icon={<EditOutlined />}
                />
                <Button
                  onClick={() => handlePrintSingleItem(item)}
                  color="blue"
                  variant="filled"
                  icon={<PrinterOutlined />}
                />
                {/* Print button with forward ref */}

                <div style={{ display: "none" }}>
                  {printItemSigle && (
                    <PrintDonor
                      ref={componentRef}
                      data={printDataSingle}
                      sigle={1}
                      dataDonor={printItemSigle}
                    />
                  )}
                </div>
                <Popconfirm
                  title="Delete the item"
                  description="Are you sure to delete?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => handleDeleteDiag(item)}
                >
                  <Button
                    disabled={!Deletevalue}
                    color="red"
                    variant="filled"
                    icon={<CloseOutlined />}
                  />
                </Popconfirm>
              </Space>
            ),
          },
        ]}
        dataSource={details}
        pagination={false}
        size="small"
        rowKey={(item) => item.id}
      />
    );
  };

  // When row expands, fetch data
  const onExpand = async (expanded, record) => {
    setExpandedRecord(record);
    if (record) {
      setPrintDataSingle(record);
    }
    if (expanded && !doctorDetailsMap[record.id]) {
      setLoadingExpandId(record.id); // Start loading

      try {
        const res = await request(`donator/${record.id}`, "get", {});
        if (res.api_donor) {
          setDoctorDetailsMap((prev) => ({
            ...prev,
            [record.id]: res.api_donor,
          }));
        }
      } catch (error) {
        console.error("Failed to fetch donor detail:", error);
      } finally {
        setLoadingExpandId(null); // Stop loading
      }
    }
  };
  useEffect(() => {
    console.log("✅ Updated printDataSingle: ", printDataSingle);
  }, [printDataSingle]);
  const handleEdit = (item) => {
    setID(item.id);
    setForm(item);
    console.log("Form data set for edit:", form);
    setOpenModel(true);
  };
  const handleEditRow = (item) => {
    setID(item.id);
    setDonorID(item.donor_id);
    setFormDiag(item);
    setOpenModelDiag(true);
  };
  // Step 1: State for Checkbox Status
  const [checkboxes, setCheckboxes] = useState({});
  const [checkedIds, setcheckedIds] = useState(0)
  useEffect(() => {
    // Flatten the checkbox states across all pages
    const flattenedCheckboxes = Object.values(checkboxes).reduce(
      (acc, pageCheckboxes) => {
        return { ...acc, ...pageCheckboxes };
      },
      {}
    );

    // Get all checked IDs
    const checkedIds = Object.keys(flattenedCheckboxes).filter(
      (id) => flattenedCheckboxes[id]
    );

    // Update the disablePrint state based on checked items
    setDisablePrint(checkedIds.length !== 0);

    console.log("This is checked IDs: ", checkedIds);
    setcheckedIds(checkedIds.length)
  }, [checkboxes]);
  // Handle individual checkbox changes
  const [selectAll, setSelectAll] = useState(false);
  // const handleCheckboxChange = (id) => {
  //   // Assuming you have access to the record data (e.g., from a data source like a table's data array)
  //   const record = list.find((item) => item.id === id); // Replace `dataSource` with your actual data array
  //   const fullname = record?.full_name_kh;

  //   // Get the current list of fullnames from local storage
  //   let storedFullnames =
  //     JSON.parse(localStorage.getItem("selectedFullnames_isCheck")) || [];

  //   setCheckboxes((prev) => {
  //     const updatedPageCheckboxes = {
  //       ...prev[currentPage],
  //       [id]: !prev[currentPage]?.[id], // Toggle checkbox
  //     };

  //     const updatedCheckboxes = {
  //       ...prev,
  //       [currentPage]: updatedPageCheckboxes,
  //     };

  //     // Flatten the checkboxes to a single array of all selected IDs
  //     const allCheckboxes = Object.values(updatedCheckboxes).flatMap(
  //       (pageCheckboxes) => Object.values(pageCheckboxes)
  //     );

  //     // Determine if all items are selected across pages
  //     const allSelected =
  //       allCheckboxes.length > 0 && allCheckboxes.every(Boolean);
  //     setSelectAll(allSelected);

  //     // If the checkbox is checked, add the fullname to local storage
  //     if (!prev[currentPage]?.[id]) {
  //       if (fullname && !storedFullnames.includes(fullname)) {
  //         storedFullnames.push(fullname);
  //       }
  //     } else {
  //       // If the checkbox is unchecked, remove the fullname from local storage
  //       storedFullnames = storedFullnames.filter((name) => name !== fullname);
  //     }

  //     // Save the updated fullnames list to local storage
  //     localStorage.setItem(
  //       "selectedFullnames_isCheck",
  //       JSON.stringify(storedFullnames)
  //     );

  //     return updatedCheckboxes;
  //   });
  // };
  // Initialize checkbox states and dataPrintCertificate from local storage
  useEffect(() => {
    // Clear selectedFullnames_isCheck when route is /blooddonation
    if (location.pathname === "/blooddonation") {
      localStorage.removeItem("selectedFullnames_isCheck");
    }

    const storedFullnames =
      JSON.parse(localStorage.getItem("selectedFullnames_isCheck")) || [];

    // Initialize checkbox states
    const initialCheckboxes = {};
    list.forEach((record) => {
      const page = 1; // Adjust for dynamic pagination
      if (!initialCheckboxes[page]) {
        initialCheckboxes[page] = {};
      }
      initialCheckboxes[page][record.id] = storedFullnames.some(
        (item) =>
          item.id === record.id &&
          item.fullname === record.full_name_kh &&
          item.ingerate_qrcode_id === record.ingerate_qrcode_id
      );
    });
    setCheckboxes(initialCheckboxes);

    // Check if all items are selected
    const allCheckboxes = Object.values(initialCheckboxes).flatMap(
      (pageCheckboxes) => Object.values(pageCheckboxes)
    );
    const allSelected =
      allCheckboxes.length > 0 && allCheckboxes.every(Boolean);
    setSelectAll(allSelected);

    // Initialize dataPrintCertificate with records from local storage
    const selectedRecords = list.filter((record) =>
      storedFullnames.some(
        (item) =>
          item.id === record.id &&
          item.fullname === record.full_name_kh &&
          item.ingerate_qrcode_id === record.ingerate_qrcode_id
      )
    );
    setDataPrintCertificate(selectedRecords);


  }, []);

  const handleCheckboxChange = (id) => {
    const record = list.find((item) => item.id === id);
    const fullname = record?.full_name_kh;
    const qrcode = record?.ingerate_qrcode_id;
    const position = record?.position;
    const phone = record?.phone1;
    const gender = record?.gender;
    // Get the current list of selected items from local storage
    let storedFullnames =
      JSON.parse(localStorage.getItem("selectedFullnames_isCheck")) || [];

    setCheckboxes((prev) => {
      const updatedPageCheckboxes = {
        ...prev[currentPage],
        [id]: !prev[currentPage]?.[id], // Toggle checkbox
      };

      const updatedCheckboxes = {
        ...prev,
        [currentPage]: updatedPageCheckboxes,
      };

      // Flatten the checkboxes to a single array of all selected IDs
      const allCheckboxes = Object.values(updatedCheckboxes).flatMap(
        (pageCheckboxes) => Object.values(pageCheckboxes)
      );

      // Determine if all items are selected across pages
      const allSelected =
        allCheckboxes.length > 0 && allCheckboxes.every(Boolean);
      setSelectAll(allSelected);

      // If the checkbox is checked, add the { id, fullname } to local storage and dataPrintCertificate
      if (!prev[currentPage]?.[id]) {
        if (fullname && !storedFullnames.some((item) => item.id === id)) {
          storedFullnames.push({ id, fullname, position, qrcode, phone, gender });
          setDataPrintCertificate((prev) => [...prev, record]);
        }
      } else {
        // If the checkbox is unchecked, remove the { id, fullname } from local storage and dataPrintCertificate
        storedFullnames = storedFullnames.filter((item) => item.id !== id);
        setDataPrintCertificate((prev) =>
          prev.filter((item) => item.id !== id)
        );
      }

      // Save the updated list to local storage
      localStorage.setItem(
        "selectedFullnames_isCheck",
        JSON.stringify(storedFullnames)
      );

      return updatedCheckboxes;
    });


  };

  const [template, setTemplate] = useState([]);
  const [contents, setCaption] = useState();
  const onHandleOpenPrintTemplate = async () => {
    setLoading(true);
    try {
      const res = await request("donatortemplate", "get");
      if (res) {
        setTemplate(res.api_template);

        console.log(template);
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setOpenTemplate(true);
    }
  };
  const [template_value, setTemplateValue] = useState([]);
  const [template_id, setTemplatID] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const onChangeTemplate = async (filename) => {
    const selected = template.find((item) => item.filename === filename);
    if (selected) {
      setTemplateValue(selected.filename);
      setCaption(selected.caption);
      setTemplatID(selected.id);
      setIsSelected(true);
    }
  };

  // Function to preprocess content and preserve spaces
  const processContent = (value) => {
    // Replace multiple spaces with &nbsp; to preserve them in HTML
    return value.replace(/ {2,}/g, (match) => "&nbsp;".repeat(match.length));
  };

  const onChagneTemplateCaption = (value) => {
    const processedContent = processContent(value); // Process spaces
    setCaption(processedContent);
  };

  const onPrintTemplate = () => {
    console.log("content", contents);
    // photo linke to  with size and postion in html
    setPrintCertificate(true);
  };
  const [loadingIcon, setLoadingIcon] = useState(false);
  const onUpdateTemplate = async () => {
    try {
      setLoadingIcon(true);
      const data = {
        id: template_id,
        caption: contents,
      };
      const res = await request("donortemplateupdate", "put", data);
      if (res) {
        openNotification("success", "Update Template Success");
      } else {
        openNotification("error", res.message || "Update failed");
      }
    } catch (err) {
      openNotification(
        "error",
        "An error occurred while updating the template"
      );
      console.error("Update error:", err);
    } finally {
      setLoadingIcon(false);
    }
  };
  const quillModules = {
    toolbar: [
      [
        {
          font: [
            "Moul",
            "Content",
            "Arial",
            "Times New Roman",
            "Helvetica",
            "Courier New",
            "Verdana",
            "Georgia",
            "Roboto",
            "Noto Sans",
          ],
        },
        {
          size: [
            "12px",
            "13px",
            "14px",
            "15px",
            "16px",
            "17px",
            "18px",
            "20px",
            "24px",
            "28px",
            "32px",
          ],
        },
        {
          lineheight: ["1", "1.15", "1.5", "2", "2.5", "3"], // custom line height dropdown in same group as size
        },
      ],
      [{ header: [1, 2, 3, 4, 5, 6] }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [
        {
          color: [
            "#000000",
            "#FFFFFF", // Black, White
            "#FF0000",
            "#00FF00",
            "#0000FF", // Red, Green, Blue
            "#FFFF00",
            "#FF00FF",
            "#00FFFF", // Yellow, Magenta, Cyan
            "#800000",
            "#808000",
            "#008000", // Maroon, Olive, Green
            "#800080",
            "#008080",
            "#000080", // Purple, Teal, Navy
            "#FFA500",
            "#FFC0CB",
            "#FFD700", // Orange, Pink, Gold
            "#A52A2A",
            "#DAA520",
            "#ADFF2F", // Brown, Goldenrod, GreenYellow
            "#C0C0C0",
            "#808080",
            "#696969", // Silver, Gray, DimGray
            "#FFB6C1", // LightPink
            "#20B2AA", // LightSeaGreen
            "#BA55D3", // MediumOrchid
            "#CD5C5C", // IndianRed
            "#9ACD32", // YellowGreen
            "#FF4500", // OrangeRed
            "#2E8B57", // SeaGreen
            "#DDA0DD", // Plum
            "#B0C4DE", // LightSteelBlue
            "#FF69B4", // HotPink
            "#98FB98", // PaleGreen
          ],
        },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };
  const [dataPrintCertificate, setDataPrintCertificate] = useState([]);


  const [modalReport, setModalReport] = useState(false)

  const handleGetReport = () => {
    setModalReport(true)
  }

  return (
    <div>
      <div className="sprinSave-container">
        {/* Your other components */}
        {loadingSpin && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>

      <div style={boxHeader}>
        <div style={{ display: "flex" }}>
          <Space>
            {boxHeaderTagText("ការគ្រប់គ្រង់ អ្នកបរិច្ចាគឈាម")}
            <div style={{ display: "flex" }}>
              <Space>
                <Input
                  onChange={(e) => {
                    const newValue = e.target.value;
                    const updatedFilter = {
                      ...objFilter,
                      search: newValue,
                    };
                    setObjFileter(updatedFilter);
                    console.log("key change:", newValue);
                    getList(updatedFilter); // Use updated filter directly
                  }}
                  placeholder="ស្វែងរក...."
                />
                <Button
                  type="primary"
                  onClick={() => {
                    setOpenModel_Filter(true);
                  }}
                  icon={<FilterOutlined />}
                />
                <Button
                  danger
                  type="primary"
                  onClick={handleClearSearch}
                  icon={<ReloadOutlined />}
                />
              </Space>
            </div>
          </Space>
        </div>
        <div style={{ display: "flex" }}>

          <Space>
            <Button
              disabled={Boolean(!checkedIds)}
              color="cyan" variant="solid"
              onClick={handlePrintQRMultiple}
              icon={<QrcodeOutlined />}
            >
              ព្រីន QRcode
            </Button>
            {Boolean(PrintValue) ? <Button
              disabled={Boolean(!checkedIds)}
              color="purple"
              variant="solid"
              onClick={onHandleOpenPrintTemplate}
              icon={<BiBadgeCheck />}
            >
              ព្រីនលិខិតសរសើរ
            </Button> : null}
            <Button
              disabled={!Addvalue}
              color="primary"
              variant="solid"
              onClick={handleGetReport}
              icon={<BsDownload />}
            >
              ទាញរបាយការណ៍
            </Button>
            <Button
              disabled={!Addvalue}
              onClick={() => {
                setOpenModel(true);
                setID(null);
                setClear(0);
              }}
              className="buttonstylekhmer"
              type="primary"
              icon={<PlusCircleOutlined />}
            >
              បង្កើតថ្មី
            </Button>
          </Space>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table
            pagination={{
              pageSize: 10,
              total: total,
              current: pageNumber,
              onChange: (page) => onChangePage(page), // ✅ Pass the new page number
            }}
            key={"key"}
            columns={columns}
            size="small"
            dataSource={list}
            expandable={{
              expandedRowRender,
              onExpand,
            }}
            rowKey="id"
          />
        )}
      </div>

      <Modal
        className="khmer-font"
        width={1000}
        onClose={closeForm}
        footer={false}
        open={openModel}
        title={id ? "កែប្រែ" : "បង្កើតថ្មី"}
      >
        <DonorRegisterForm
          closeForm={closeForm}
          updateid={id}
          update_form={form}
        />
      </Modal>

      <Modal
        className="khmer-font"
        width={1000}
        onClose={closeFormDiag}
        footer={false}
        open={openModelDiag}
        title={
          id
            ? "កែប្រែ ការវិនិច្ឆ័យរបស់គ្រូពេទ្យ"
            : "បង្កើតថ្មី ការវិនិច្ឆ័យរបស់គ្រូពេទ្យ"
        }
      >
        <DonationDiagnosis
          item_id={id}
          donor_id={donor_id}
          update_form={formDiag}
          closeFormDiag={closeFormDiag}
        />
      </Modal>
      <Modal
        width={1024}
        open={openTemplate}
        title="Print Certificate"
        footer={[
          <Button
            key="print"
            type="primary"
            disabled={!isSelected}
            style={{ marginRight: 10 }}
            onClick={onPrintTemplate}
          >
            Print Certificate
          </Button>,
          <Button
            key="update"
            color="default"
            variant="solid"
            loading={loadingIcon}
            icon={<SaveOutlined />}
            disabled={!isSelected}
            style={{ marginRight: 10 }}
            onClick={onUpdateTemplate}
          >
            Update Template
          </Button>,
          <div key="hidden-print" style={{ display: "none" }}>
            <PrintCertificate
              ref={componentRef}
              background_image={linkPath + template_value}
              data={dataPrintCertificate}
              content={contents}
            />
          </div>,
          <Button key="cancel-template" onClick={() => setOpenTemplate(false)}>
            Cancel
          </Button>,
        ]}
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <Select
          className="styleTageStatusForm"
          placeholder="Select a Template"
          onChange={onChangeTemplate}
          value={template_value}
        >
          {template.map((option) => (
            <Option key={option.id} value={option.filename}>
              {option.template_name}
            </Option>
          ))}
        </Select>

        <div style={{ height: "350px", overflow: "auto", marginTop: 16 }}>
          <ReactQuill
            style={{ height: 300 }}
            value={contents}
            onChange={onChagneTemplateCaption} // Use the processed change handler
            modules={quillModules}
            theme="snow"
          />
        </div>
      </Modal>
      <div ref={printRef} className="print-only">
        {/* <FormPantient update_form={form} updateid={id} /> */}
      </div>

      <Modal title="ស្វែងរក" open={openModel_Filter} footer={false}>
        <FilterDate
          closeModelFilter={() => setOpenModel_Filter(false)}
          onFilterDateChange={handleFilterDateChange}
        />
      </Modal>


      <Modal title="ទាញរបាយការណ៍" open={modalReport} footer={true}>
        <FilterDateTime
          closeModelFilter={() => setModalReport(false)}
          onFilterDateChange={handleDownloadReport}
        />
      </Modal>
    </div>
  );
};
export default BloodDonation;
